import { useCallback, useEffect, useState } from 'react';
import Helmet from 'react-helmet';

import { useGlobalAuthStore } from '@Stores/global/auth';

import ForgotForm from '../components/ForgotForm';

const FEEDBACKS = {
  'is-not-admin': 'Only administrators can reset password.',
  unchanged: 'Internal error',
  ok: "We've sent you the validation code.",
  'not-found': 'Invalid e-mail',
};

export default function ForgotFormLayout() {
  const { forgot: { generateCode, resetPassword, verfifyCode } } = useGlobalAuthStore()
  const [isVerified, setIsVerified] = useState(null)
  const [isValidated, setIsValidated] = useState(null)
  const [feedback, setFeedback] = useState(null)
  const [code, setCode] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const reload = useCallback(async () => {
    setIsVerified(null)
    setIsValidated(null)
    setFeedback(null)
    setCode(null)
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')

    if (code) {
      const isVerified = await verfifyCode(code)
      setCode(code)
      setIsVerified(isVerified)
      setIsValidated(isVerified)
      setFeedback(!isVerified ? { type: "danger", text: "The validation code is invalid or has expired " } : null)
    }
  }, [verfifyCode])

  useEffect(() => {
    reload()
  }, [reload])

  async function handleSubmit(payload) {
    setFeedback(null)
    setIsLoading(true)
    try {
      if (payload.email) {
        payload.callback_url = `${window.location.origin}${window.location.pathname}?code=`
        const data = await generateCode(payload)
        setFeedback({ type: data === 'not-found' ? 'danger' : 'warning', text: FEEDBACKS[data] })
        setIsVerified(data === 'ok')
      } else {
        payload.validationCode = code
        const data = await resetPassword(payload)
        setIsValidated(null)
        setIsVerified(data)
        setFeedback({ type: "danger", text: data ? "Password changed" : "The code has expired!" })
      }
    } finally {
      setIsLoading(false)
    }
  }

  return <div>
    <Helmet title="Reset Password" />
    <ForgotForm handleSubmit={handleSubmit} isValidated={isValidated} isVerified={isVerified} feedback={feedback} isLoading={isLoading} />
  </div>
}
